import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, Package, Smartphone, ShieldCheck, Mail, Zap } from 'lucide-react';
const steps = [{
  icon: Package,
  number: '1',
  text: 'Hacés tu pedido hoy (sin pagar nada ahora).'
}, {
  icon: Smartphone,
  number: '2',
  text: 'Nosotros preparamos y enviamos tu Kit en 24–48 hs hábiles.'
}, {
  icon: QrCode,
  number: '3',
  text: 'El mensajero llega a tu puerta, te muestra el QR y vos escaneás con Mercado Pago desde tu celular. Listo.'
}];
export function PaymentSection() {
  return <section className="py-20 px-4 md:px-8 bg-white" data-id="element-216">
      <div className="max-w-3xl mx-auto" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-218">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-widest text-[#009ee3] uppercase border border-[#009ee3]/30 rounded-full bg-[#009ee3]/5" data-id="element-219">
            PAGO CONTRA ENTREGA
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown-deep mb-4" data-id="element-220">
            ¿No querés pagar por adelantado?
          </h2>
          <p className="text-xl text-brown-medium" data-id="element-221">
            No hay problema. Ofrecemos algo que pocas tiendas se animan a hacer:
          </p>
        </motion.div>

        {/* Main callout */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-[#009ee3]/5 border-2 border-[#009ee3]/30 rounded-3xl p-8 mb-10 text-center" data-id="element-222">
          <div className="flex justify-center mb-4" data-id="element-223">
            <div className="w-16 h-16 rounded-2xl bg-[#009ee3]/10 flex items-center justify-center" data-id="element-224">
              <QrCode className="w-8 h-8 text-[#009ee3]" data-id="element-225" />
            </div>
          </div>
          <p className="text-xl md:text-2xl font-bold text-brown-deep leading-snug" data-id="element-226">
            💰 PAGÁS CON QR DE MERCADO PAGO
            <br data-id="element-227" />
            <span className="text-[#009ee3]" data-id="element-228">
              CUANDO EL PAQUETE LLEGA A LA PUERTA DE TU CASA.
            </span>
          </p>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-229">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15,
          duration: 0.5
        }} className="flex flex-col items-center text-center p-6 rounded-2xl bg-cream border border-gold/10" data-id="element-230">
              <div className="w-10 h-10 rounded-full bg-[#009ee3] text-white font-bold text-lg flex items-center justify-center mb-4 shadow-md" data-id="element-231">
                {step.number}
              </div>
              <step.icon className="w-6 h-6 text-brown-medium mb-3" data-id="element-232" />
              <p className="text-brown-medium text-sm leading-relaxed" data-id="element-233">
                {step.text}
              </p>
            </motion.div>)}
        </div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10" data-id="element-234">
          {[{
          icon: ShieldCheck,
          text: 'Sin efectivo. Sin transferencia previa. Sin riesgo de perder tu plata.'
        }, {
          icon: Package,
          text: 'Enviamos a todo el país con número de seguimiento a tu email.'
        }, {
          icon: Zap,
          text: 'Solo pagás cuando lo tenés en tus manos.'
        }].map((item, i) => <div key={i} className="flex items-start gap-3 p-4 rounded-xl bg-green-50 border border-green-100" data-id="element-235">
              <item.icon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-236" />
              <p className="text-sm text-brown-medium leading-relaxed" data-id="element-237">
                {item.text}
              </p>
            </div>)}
        </motion.div>

        {/* Digital bonus callout */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-coral/5 border border-coral/20 rounded-2xl p-6 flex items-start gap-4" data-id="element-238">
          <Mail className="w-8 h-8 text-coral flex-shrink-0 mt-1" data-id="element-239" />
          <div data-id="element-240">
            <p className="font-bold text-brown-deep mb-1" data-id="element-241">
              ⚡ Tu acceso al Ebook + los 3 Bonos digitales llega por email{' '}
              <span className="text-coral" data-id="element-242">HOY mismo</span>
            </p>
            <p className="text-brown-medium text-sm leading-relaxed" data-id="element-243">
              Apenas confirmás el pedido, recibís todo el contenido digital al
              instante. No tenés que esperar el envío físico para empezar.{' '}
              <strong className="text-brown-deep" data-id="element-244">
                Empezás hoy. Pagás con QR cuando llega.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}